import React, { Component } from 'react'
import { ENTRY_SUGGESTION_QUERY, DELETE_ENTRY_SUGGESTION, UPDATE_ENTRY_SUGGESTION } from "../../queries/Queries"
import { IconButton } from '@mui/material';
import { FaLockOpen, FaLock, FaSortUp, FaSortDown } from "react-icons/fa";
import { useMutation, useQuery } from '@apollo/react-hooks';
import CircularProgressIndicator from '../elements/CircularProgressIndicator';
import { FaCheck, FaBan, FaTrash} from "react-icons/fa";
// import Skill from './Skill';
import { AUTH_TOKEN } from '../../constants';
import EntrySuggestion from './EntrySuggestion';
import { flattenStrapiData } from '../../utils/utilities';


class EntrySuggestionList extends Component {
  state = {
    locked: true,
    error: "",
    columns: [
        {column: "id",                 direction: "asc"},
        {column: "language_code",      direction: "asc", filter: ""},
        {column: "creator.fullname",   direction: "asc", filter: ""},
        {column: "suggested_entry",    direction: "asc", filter: ""},
        {column: "created_for",        direction: "asc",},
        {column: "vehicle_brand.name", direction: "asc", filter: ""},
        {column: "approved"          },
        {column: "createdAt",       direction: "asc"},
        {column: "updatedAt",       direction: "asc"},
    ],
    sortBy: "createdAt:asc",
    filters: {suggested_entry: {containsi: ""} }
  }

  
  onChangeFilter(e, index) {
    let columns = this.state.columns;
    for(let i = 0; i < columns.length; i++) {
        if(columns[i].filter !== undefined)
          columns[i].filter = ""
    }
    columns[index].filter = e.target.value
    // console.log("filter: " + columns[index].filter)
    this.setState({columns: columns,})
}

onSubmitFilter(e, index) {
  e.preventDefault();
  let columns = this.state.columns;
  // console.log("columns " + columns[index].column + " filter: "+ columns[index].filter) 
  // columns[index].filter = e.target.value
  let filters = { 
    [columns[index].column]: {containsi: columns[index].filter}
  }
  this.setState({filters: filters,})
}

  handleLockChange(e) {
    this.setState({locked: !this.state.locked});
  }
  updateState() {
    this.setState({sortBy: "updatedAt:desc"})
  }
  
  updateColumn(at, forceDirection) {
    let column = this.state.columns[at]
    if(column.direction === undefined)
        return;

    column.direction = forceDirection !== undefined ? forceDirection : column.direction === 'asc' ? 'desc' : 'asc';
    let columns = this.state.columns;
    for(let i = 0; i < columns.length; i++) {
        if(columns[i].direction === undefined)
            continue;
        if(i === at)
            columns[at] = column
        else
            columns[i].direction = 'asc'
    }
    let sortBy =  column.column + ":" + column.direction
    this.setState({columns: columns, sortBy: sortBy})
  }

  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    if(!token) {
      return(
        <div>
          <span className="Error">You must be loged in first</span>
        </div>
      )
    }

    return (
        <div>
          <IconButton onClick={this.handleLockChange.bind(this)} >{this.state.locked ? <FaLock/> : <FaLockOpen/> }</IconButton>
          <br/>
          <div><span className="error">{this.state.error}</span></div>
          <GetList
            token={token} 
            locked={this.state.locked}
            updateColumn={this.updateColumn.bind(this)}
            onChangeFilter={this.onChangeFilter.bind(this)}
            onSubmitFilter={this.onSubmitFilter.bind(this)}
            columns={this.state.columns}
            sortBy={this.state.sortBy}
            filters={this.state.filters}
          />
      </div>
    )
  }
}

function GetList({locked, token, updateColumn, onChangeFilter, onSubmitFilter, columns, sortBy, filters}) {
  // console.log(`sortBy: ${sortBy}, filters: ${JSON.stringify(filters)}`)
  const {data, loading, error, refetch} = useQuery(ENTRY_SUGGESTION_QUERY, {variables: {sortBy: sortBy, filters: filters}})
  
  if(error) return(<span className="error">{error.message}</span>)
  
  function sort(columnNumber, forceDirection) {
    updateColumn(columnNumber, forceDirection)
    refetch({variables: {sortBy: sortBy, filters: filters}})
  }

  function getArrow(direction) {
    return direction === "asc" ? <FaSortUp/> : <FaSortDown/>
  }
 
  function filter(e, index) {
    onChangeFilter(e, index)
  }

  function getColumnHeader(index) {
    return <th ><div><h4>{columns[index].column}</h4>{columns[index].filter !== undefined ? 
    <form onSubmit={(e) => onSubmitFilter(e, index)}><input  value={columns[index].filter} onChange={(e) => filter(e, index)} /></form>
     : ""} <div onClick={columns[index].direction !== undefined ? () => sort(index) : () => {}}>{columns[index].direction !== undefined ? getArrow(columns[index].direction) : ""}</div></div></th>;
    }

  let entrySuggestions = data?.entrySuggestions?.data
  
  return (
    <div>
    { loading ? <CircularProgressIndicator size={60} /> : <table className="table table-bordered">
      <thead>
        <tr>
          {getColumnHeader(0)}
          {getColumnHeader(1)}
          {getColumnHeader(2)}
          {getColumnHeader(3)}
          {getColumnHeader(4)}
          {getColumnHeader(5)}
          {getColumnHeader(6)}
          {getColumnHeader(7)}
          {getColumnHeader(8)}
          {token && !locked && <th><h4>Edit</h4></th>}
          {/* {token && !locked && <th><h4>Delete</h4></th>} */}
        </tr>
      </thead> 
        <tbody>
        {entrySuggestions !== undefined ? entrySuggestions.map(entrySuggestion => {

          entrySuggestion = flattenStrapiData(entrySuggestion)
          return  <EntrySuggestion 
          key={entrySuggestion.id+"_"+entrySuggestion.approved} 
          locked={locked} 
          entrySuggestion={entrySuggestion}>
            {/* <Delete refetch={() => refetch()}/> */}
            <Update refetch={() => sort(7, "desc")}/>
            <Delete refetch={() => sort(7, "desc")}/>
          </EntrySuggestion>
        }) : "No body found"}
      </tbody>
    </table>
    }
    </div>
  )
}

function Delete({id, refetch}) {
  const [deleteTranslation, {loading, error}] = useMutation(DELETE_ENTRY_SUGGESTION)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) alert("Delete Mutation Error: "+ error.message)
  return (
      <IconButton onClick={e => deleteTranslation({variables: {id: id}})
      .then(data => refetch())
      .catch(e => alert("Execute Update Mutation Error: "+e))}><FaTrash/></IconButton>
  )
}

function Update({id, state, refetch}) {
  const [upadateEntry, {loading, error}] = useMutation(UPDATE_ENTRY_SUGGESTION)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) {
    console.log("ERROR:"+error)
    alert("Update Mutation Error: "+ error.message)
  }

  let approved = state.approved ? false : true
  // console.log("approved updated: "+approved)
  return (
      <IconButton onClick={e => {
      upadateEntry({variables: {id: id, approved: approved, suggested_entry: state.suggested_entry}})
      .then(data => refetch())
      .catch(e => alert("Execute Update Mutation Error: "+e))
    }
    }>{approved ? <FaCheck/> : <FaBan/>}</IconButton>
  )
}

export default EntrySuggestionList